/**
 * @author Fernando Ruano
 * @file index.js
 * @description Medical Parameters Container
 */

// Dependencies
import React from 'react';

// Components
import AppRoutes from '@nephro/components/AppRoutes';
import AppCardLayout from '@nephro/components/AppCardLayout';

// Routes
import routes from './routes';

/**
 * Medical Parameters Container.
 * @return { Node } React Medical Parameters container.
 */
const MedicalParametersContainer = () => {
  return (
    <AppCardLayout>
      <AppRoutes routes={routes} />
    </AppCardLayout>
  );
};

/**
 * @name MedicalParameters.propTypes
 * @type { Object }
 */
MedicalParametersContainer.propTypes = {};

/**
 * Default props
 */
MedicalParametersContainer.defaultProps = {};

export default MedicalParametersContainer;
